import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../FormInput';
import { formatNumber } from '../../utils';
import { formatFloat } from '../../../../../../utils';

function CompoundAddition({ name, references, constants, calculateOnRender, ...props }) {
    const [hasBeenCalculated, setHasBeenCalculated] = useState(false);
    const {
        watch,
        setValue,
        clearErrors,
        trigger,
        getValues,
        formState: { isSubmitted, dirtyFields },
    } = useFormContext();

    useEffect(() => {
        const calculateValue = () => {
            const values = getValues([...references]);
            if (constants) values.push(...constants);

            const summed = values.reduce((prev, current) => formatNumber(prev, true) + formatNumber(current, true), 0);
            const result = !Number.isNaN(summed) ? summed : 0;

            // calling setValue does not call onChange
            // validation methods need to manually be called
            clearErrors([name]);
            const { rounding } = props.props;
            const { formatNumberWithCommas } = props.props;
            const newValue = formatNumberWithCommas ? formatFloat(result, rounding ?? 1, 0) : parseFloat(result.toFixed(rounding ?? 1));
            setValue(name, newValue, { shouldDirty: true });
            setHasBeenCalculated(true);
            if (isSubmitted) {
                trigger([name]);
            }
        };

        if (references.some((ref) => dirtyFields[ref]) || hasBeenCalculated || calculateOnRender) {
            calculateValue();
        }
    }, [...watch([...references])]);

    return <FormInput name={name} {...props} />;
}

export default CompoundAddition;
